import "core-js/modules/es6.regexp.split";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.regexp.to-string";
import _defineProperty from "/var/log/nginx/source/CateringManagerX/CateringManager_Html/node_modules/_@babel_runtime-corejs2@7.13.7@@babel/runtime-corejs2/helpers/esm/defineProperty";
// import Bus from '../FaceTeach/FaceTeachStatistics/bus.js';
import PreparingCourseware from "components/PreparingCourseware.vue";
import { GetSourceInfo } from 'api/v1.design.courseware';
import directoryConfiguration from "components/directoryConfiguration.vue";
import ManagerShare from "components/ManagerShare.vue";
import SourceListReplace from "components/CatalogSourceListReplace.vue";
import { getVoteInfo } from "api/v1.design.coursechaptersection";
import { ContainerMixin, ElementMixin, HandleDirective } from 'vue-slicksort';
import SourceList from "components/CatalogSourceList.vue";
var SortableList = {
  name: 'sortablelist',
  mixins: [ContainerMixin],
  template: "\n    <ul class='sortable-list'>\n      <slot />\n    </ul>\n  "
};
var SortableItem = {
  name: 'sortableitem',
  mixins: [ElementMixin],
  template: "\n    <li class='sortable-list-item'>\n      <slot />\n    </li>\n  "
};
export default {
  data: function data() {
    var _ref;

    return _ref = {
      sourceDataList: [],
      saveSate: false,
      dialogDirectoryConfiguration: false,
      info: {
        CellName: "",
        content: ""
      },
      chapterName: '',
      titleType: "",
      dialogVisibleDiscuss: false,
      dialogVisiblequiz: false,
      dialogVisibleBrainstorming: false,
      managerSchool: false,
      managerPatner: false
    }, _defineProperty(_ref, "chapterName", ""), _defineProperty(_ref, "btnShow", false), _defineProperty(_ref, "isImport", {
      state: false
    }), _defineProperty(_ref, "showSchoolCourse", false), _defineProperty(_ref, "activityList", []), _defineProperty(_ref, "dialogFormVisibleSouce", false), _defineProperty(_ref, "dialogVisiblePreviewResources", false), _defineProperty(_ref, "activityPagination", {
      pageIndex: 1,
      pageSize: 10,
      totalCount: 10
    }), _defineProperty(_ref, "checkStatusData", {
      checkBoxState: false
    }), _defineProperty(_ref, "activityDialogVisible", false), _defineProperty(_ref, "setTree", []), _defineProperty(_ref, "inputShow", -1), _defineProperty(_ref, "fatherIcon", -1), _defineProperty(_ref, "fatherIndex", -1), _defineProperty(_ref, "fatherInput", -1), _defineProperty(_ref, "twoInput", -1), _defineProperty(_ref, "childInput", -1), _defineProperty(_ref, "threeInput", -1), _defineProperty(_ref, "manyInput", -1), _defineProperty(_ref, "grandInput", -1), _defineProperty(_ref, "fourInput", -1), _defineProperty(_ref, "fiveIpnut", -1), _defineProperty(_ref, "sixInput", -1), _defineProperty(_ref, "oneChild", -1), _defineProperty(_ref, "towChild", -1), _defineProperty(_ref, "threeChild", -1), _defineProperty(_ref, "oneGrand", -1), _defineProperty(_ref, "twoGrand", -1), _defineProperty(_ref, "threeGrand", -1), _defineProperty(_ref, "fourGrand", -1), _defineProperty(_ref, "addCourseDialogVisible", false), _defineProperty(_ref, "addCourseDialogVisibleMooc", false), _defineProperty(_ref, "tdialogVisible", false), _defineProperty(_ref, "myfiledialogVisible", false), _defineProperty(_ref, "chapterdialogFormVisible", false), _defineProperty(_ref, "sectiondialogFormVisible", false), _defineProperty(_ref, "folderdialogFormVisible", false), _defineProperty(_ref, "picworddialogFormVisible", false), _defineProperty(_ref, "visible", false), _defineProperty(_ref, "isupload", false), _defineProperty(_ref, "isShow", true), _defineProperty(_ref, "isfiles", false), _defineProperty(_ref, "tuwenName", ''), _defineProperty(_ref, "content", ''), _defineProperty(_ref, "folderName", ''), _defineProperty(_ref, "formLabelWidth", '120px'), _defineProperty(_ref, "fileList", []), _defineProperty(_ref, "uploadUrl", ''), _defineProperty(_ref, "files", []), _defineProperty(_ref, "checkedList", []), _defineProperty(_ref, "pageSize", 8), _defineProperty(_ref, "pageIndex", 1), _defineProperty(_ref, "IsLoad", false), _defineProperty(_ref, "userId", ''), _defineProperty(_ref, "chapterName", ''), _defineProperty(_ref, "sectionName", ''), _defineProperty(_ref, "parentId", ''), _defineProperty(_ref, "level", 0), _defineProperty(_ref, "topicId", ''), _defineProperty(_ref, "parentsId", ''), _defineProperty(_ref, "firstName", ''), _defineProperty(_ref, "nodeName", ''), _defineProperty(_ref, "childNode", ''), _defineProperty(_ref, "sonsName", ''), _defineProperty(_ref, "topIndex", ''), _defineProperty(_ref, "picworddialogFormVisible", false), _defineProperty(_ref, "cellId", ''), _defineProperty(_ref, "item", []), _defineProperty(_ref, "Ids", []), _defineProperty(_ref, "loadingShow", false), _defineProperty(_ref, "fatherId", ''), _defineProperty(_ref, "grandIndex", ''), _defineProperty(_ref, "seIndex", ''), _defineProperty(_ref, "seIndex1", ''), _defineProperty(_ref, "seIndex2", ''), _defineProperty(_ref, "tuwenIndex", ''), _defineProperty(_ref, "tuwenIndex1", ''), _defineProperty(_ref, "tuwenIndex2", ''), _defineProperty(_ref, "uploadIndex", ''), _defineProperty(_ref, "uploadIndex1", ''), _defineProperty(_ref, "uploadIndex2", ''), _defineProperty(_ref, "uploadIndex3", ''), _defineProperty(_ref, "dtype", 0), _defineProperty(_ref, "replaceIndex", ''), _defineProperty(_ref, "replaceIndex1", ''), _defineProperty(_ref, "replaceIndex2", ''), _defineProperty(_ref, "replaceIndex3", ''), _defineProperty(_ref, "prevent", false), _defineProperty(_ref, "dialogShow", false), _defineProperty(_ref, "sdialogVisible", false), _defineProperty(_ref, "isParticipate", false), _defineProperty(_ref, "voteInfo", {
      ActivityName: "",
      ActivityContent: "",
      DocJson: [],
      VoteType: 0,
      DataJson: []
    }), _defineProperty(_ref, "info", {}), _defineProperty(_ref, "sourceId", ''), _defineProperty(_ref, "value", []), _defineProperty(_ref, "hierarchy", ''), _defineProperty(_ref, "showReplaceDialog", false), _defineProperty(_ref, "dialogInteract", false), _defineProperty(_ref, "dialogHomework", false), _defineProperty(_ref, "replaceId", ""), _defineProperty(_ref, "replaceCellId", ""), _defineProperty(_ref, "replaceType", 0), _defineProperty(_ref, "InteractList", []), _defineProperty(_ref, "activityType", ""), _defineProperty(_ref, "Level1", '第{{index}}章'), _defineProperty(_ref, "Level2", '第{{index}}节'), _defineProperty(_ref, "Level3", '第{{index}}讲'), _defineProperty(_ref, "NumType1", '1'), _defineProperty(_ref, "NumType2", '1'), _defineProperty(_ref, "NumType3", '1'), _defineProperty(_ref, "LevelData", {}), _ref;
  },
  props: {
    courseId: {
      type: String,
      default: 'xwglaaqofilcx9i0-cihha'
    }
  },
  components: {
    ManagerShare: ManagerShare,
    SortableItem: SortableItem,
    SortableList: SortableList,
    SourceList: SourceList,
    PreparingCourseware: PreparingCourseware,
    directoryConfiguration: directoryConfiguration,
    SourceListReplace: SourceListReplace
  },
  directives: {
    handle: HandleDirective
  },
  filters: {
    priceFmt: function priceFmt(n, str) {
      if (!/(^[1-9]\d*$)/) {
        return '非法数字';
      }

      var nString = n.toString();
      var uppercase = '千百亿千百十万千百十个';
      var nLength = nString.length;
      var newStr = '';

      if (uppercase.length - nLength < 0) {
        return '数字过长';
      }

      uppercase = uppercase.substr(uppercase.length - nLength);

      for (var i = 0; i < nLength; i++) {
        newStr += '零一二三四五六七八九'.charAt(nString[i]) + uppercase.charAt(i);
      }

      newStr = newStr.substr(0, newStr.length - 1);

      if (nLength < 3) {
        newStr = newStr.replace('一十', '十').replace('十零', '十');
      } else {
        newStr = newStr.replace('十零', '十');
      }

      newStr = newStr.replace('一十', '十').replace('十零', '十');
      return str.replace('\{\{index\}\}', newStr);
    }
  },
  created: function created() {
    var that = this;
    this.getCatalogConfig();
    this.newGetCourseWareTree();
  },
  methods: {
    Receive: function Receive() {
      this.saveSate = false;
      this.dialogDirectoryConfiguration = false;
      this.getCatalogConfig();
    },
    //获取课程课件目录配置
    getCatalogConfig: function getCatalogConfig() {
      var self = this;
      this.$http.post('/api/XOrg/BookMaterial/getCoursewareCatalogConfig', {
        courseId: this.courseId
      }).then(function (res) {
        if (res.code > 0) {
          self.LevelData = res.levelData;
          self.Level1 = res.levelData.Level1Format;
          self.NumType1 = res.levelData.Level1Num;
          self.Level2 = res.levelData.Level2Format;
          self.NumType2 = res.levelData.Level2Num;
          self.Level3 = res.levelData.Level3Format;
          self.NumType3 = res.levelData.Level3Num;
        }
      });
    },
    formatJson: function formatJson(filterVal, jsonData) {
      return jsonData.map(function (v) {
        return filterVal.map(function (j) {
          return v[j];
        });
      });
    },
    export2Excel: function export2Excel() {
      var _this = this;

      require.ensure([], function () {
        var _require = require("../../../../vendor/Export2Excel"),
            export_json_to_excel = _require.export_json_to_excel;

        var tHeader = ["教材名称", "模块名称", "话题名称", "单元名称", "url"];
        var filterVal = ["bookName", "moduleName", "topicName", "cellName", "url"];
        var list = _this.sourceDataList;

        var data = _this.formatJson(filterVal, list);

        export_json_to_excel(tHeader, data, "资源表");
      });
    },
    //导出excel提示
    exportTips: function exportTips() {
      var that = this;
      that.$http.post("/api/manager/BookMaterial/excelSource", {
        courseId: that.courseId
      }).then(function (rst) {
        if (rst.code > 0) {
          that.export2Excel();
          that.sourceDataList = rst.cellList;
        }
      });
    },
    // 资源子组件传回来的值
    parentReplace: function parentReplace(id) {
      this.replaceId = id;
    },
    // 替换
    handleCommand: function handleCommand(command) {
      switch (command.type) {
        case 'ziyuan':
          this.replaceIndex = command.index;
          this.replaceIndex1 = command.index1;
          this.replaceIndex2 = command.index2;
          this.replaceIndex3 = command.index3;
          this.replaceLevel = command.level;
          this.showReplaceDialog = true;
          this.replaceCellId = command.id;
          break;

        case 'zuoye':
          this.replaceIndex = command.index;
          this.replaceIndex1 = command.index1;
          this.replaceIndex2 = command.index2;
          this.replaceIndex3 = command.index3;
          this.replaceLevel = command.level;
          this.dialogHomework = true;
          this.replaceCellId = command.id;
          this.showhomeWork();
          break;

        case 'hudong':
          this.replaceIndex = command.index;
          this.replaceIndex1 = command.index1;
          this.replaceIndex2 = command.index2;
          this.replaceIndex3 = command.index3;
          this.replaceLevel = command.level;
          this.dialogInteract = true;
          this.replaceCellId = command.id;
          this.getSchoolActivityList();
          break;

        default:
          break;
      }
    },
    //获取互动数据
    getSchoolActivityList: function getSchoolActivityList() {
      var that = this;
      this.$http.post('/api/manager/SchoolCourseShare/getSchoolActivityList', {
        courseId: this.courseId,
        activityType: ""
      }).then(function (rst) {
        if (rst.code > 0) {
          that.InteractList = rst.list;
          that.activityPagination = res.pagination;
        } else {
          that.$message.warning(rst.msg);
        }
      });
    },
    // 资源
    replaceCourseware: function replaceCourseware() {
      this.replaceType = 1;
      this.ReplaceCatalogInfo();
    },
    // 作业
    importHomework: function importHomework(id, type) {
      this.replaceType = 5;
      this.replaceId = id;
      this.ReplaceCatalogInfo();
    },
    // 互动
    importInteract: function importInteract(id, type) {
      this.replaceId = id;
      this.replaceType = type;
      this.ReplaceCatalogInfo();
    },
    //替换
    ReplaceCatalogInfo: function ReplaceCatalogInfo() {
      var that = this;
      this.$http.post('/api/manager/BookMaterial/addCatalogInfo', {
        sourceId: this.replaceId,
        type: this.replaceType,
        cellId: this.replaceCellId
      }).then(function (rst) {
        if (rst.code > 0) {
          // that.newGetCourseWareTree();
          // let replaceList = [];
          if (that.replaceLevel == 3) {
            var gatherList = that.setTree[that.replaceIndex].children[that.replaceIndex1].children[that.replaceIndex2];
            Object.assign(gatherList, rst.CellInfo);
            console.log(that.setTree);
          } else {
            var _gatherList = that.setTree[that.replaceIndex].children[that.replaceIndex1].children[that.replaceIndex2].children[that.replaceIndex3];
            Object.assign(_gatherList, rst.CellInfo);
          }

          that.replaceCellId = "";
          that.replaceId = "";
          that.showReplaceDialog = false;
          that.dialogHomework = false;
          that.dialogInteract = false;
        } else {
          that.$message.warning(rst.msg);
        }
      });
    },
    saveConfigeInfo: function saveConfigeInfo() {
      this.saveSate = true;
    },
    //批量导入目录
    handleSelectionChangeStu: function handleSelectionChangeStu(val) {
      var _this2 = this;

      this.checkBoxIds = [];
      val.forEach(function (row) {
        if (row) {
          _this2.checkBoxIds.push(row.StudentId);
        }
      });
    },
    // 搜索
    getsearch: function getsearch() {
      var self = this;
      this.loadingShow = true;
      this.$http.post('/api/XOrg/CourseSectionIndex/getModuleList', {
        courseId: self.courseId,
        moduleName: self.chapterName
      }).then(function (res) {
        var chartList = [];

        if (res.code > 0) {
          if (res.list.length == 0) {
            self.setTree = [];
          } else {
            res.list.forEach(function (element) {
              var obj = {
                id: element.Id,
                index: element.index,
                isFirstModule: element.isFirstModule,
                name: element.ModuleName,
                sortOrder: element.sortOrder,
                Topnode: false,
                children: []
              };
              chartList.push(obj);
              self.setTree = chartList;
            });
          }

          self.userId = res.userId;
          self.IsLoad = true;
          self.loadingShow = false;
        } else {
          self.$message.warning(res.msg);
        }
      });
    },
    catalogConfigure: function catalogConfigure() {
      this.$router.push({
        name: "directoryConfiguration",
        params: {
          courseId: this.courseId
        }
      });
    },
    // 传值确定导入
    allImport: function allImport() {
      this.isImport = {
        state: true
      };
    },
    //关闭dialog并刷新数据
    closeDialog: function closeDialog() {
      this.showSchoolCourse = false;
      this.newGetCourseWareTree();
    },
    // 切换本校、第三方显示隐藏按钮返回函数
    getTabMsg: function getTabMsg(val) {
      if (val == "0" && this.managerSchool == false) {
        this.btnShow = false;
      } else if (val == "1" && this.managerPatner == false) {
        this.btnShow = false;
      } else {
        this.btnShow = true;
      }
    },
    // 点击本校课程显示隐藏按钮返回函数
    getMsg: function getMsg(val) {
      if (val == true) {
        this.btnShow = true;
        this.managerSchool = true;
      } else {
        this.btnShow = false;
        this.managerSchool = false;
      }
    },
    // 单位库导入完成回调
    ImportCourse: function ImportCourse() {
      this.showSchoolCourse = false;
    },
    // 点击外校课程显示隐藏按钮返回函数
    getMsgPatner: function getMsgPatner(val) {
      if (val == true) {
        this.btnShow = true;
        this.managerPatner = true;
      } else {
        this.btnShow = false;
        this.managerPatner = false;
      }
    },
    //打开从资源库导入目录弹窗
    importCataLog: function importCataLog() {
      this.showSchoolCourse = true;
    },
    // 父组件监听子组件关闭事件
    parentCloseListen: function parentCloseListen(val, list) {
      console.log(list);
      this.dialogFormVisibleSouce = false;
      this.sourceList(list);
    },
    sourceList: function sourceList(list) {
      var self = this;
      var sourceList = [];
      list.forEach(function (element) {
        var obj = {
          CategoryName: element.CategoryName,
          CellContent: element.CellContent,
          CellName: element.CellName,
          CellType: element.CellType,
          CourseId: element.CourseId,
          DateCreated: element.DateCreated,
          DateModified: element.DateModified,
          DocId: element.DocId,
          ParentId: element.ParentId,
          ResId: element.ResId,
          TableName: element.TableName,
          TopicId: element.TopicId
        };
        sourceList.push(obj);
      });

      if (self.level == 3) {
        self.setTree[self.seIndex].children[self.seIndex1].children.push(sourceList[0]);
        self.activityDialogVisible = false;
        self.getTreedata(self.topicId, self.seIndex, self.seIndex1);
      } else if (self.level == 4) {
        self.setTree[self.seIndex].children[self.seIndex1].children[self.seIndex2].children.push(sourceList[0]);
        self.getFourdata(self.parentsId, self.seIndex, self.seIndex1, self.seIndex2, self.level);
        self.activityDialogVisible = false;
      }
    },
    handleClose: function handleClose() {
      this.activityDialogVisible = false;
      this.dialogFormVisibleSouce = false;
      this.checkStatusData = {
        checkBoxState: true
      };
    },
    // 互动导入
    saveCourseProcessCellComment: function saveCourseProcessCellComment(activtyId, activitytype) {
      var self = this;
      this.$http.post('/api/XOrg/CourseSectionIndex/saveCourseProcessCellComment', {
        courseId: this.courseId,
        topicId: this.topicId,
        cellLevel: this.level,
        cellId: this.cellId,
        parentId: this.parentsId,
        activtyId: activtyId,
        maxSortOrder: this.maxSortOrder,
        activitytype: activitytype
      }).then(function (res) {
        if (res.code > 0) {
          var list = [];
          res.cellList.forEach(function (element) {
            var obj = {
              CategoryName: element.CategoryName,
              CellContent: element.CellContent,
              CellName: element.CellName,
              CellType: element.CellType,
              CourseId: element.CourseId,
              DateCreated: element.DateCreated,
              DateModified: element.DateModified,
              DocId: element.DocId,
              ParentId: element.ParentId,
              ResId: element.ResId,
              TableName: element.TableName,
              TopicId: element.TopicId
            };
            list.push(obj);
          });

          if (self.level == 3) {
            self.setTree[self.tuwenIndex].children[self.tuwenIndex1].children.push(list[0]);
            self.activityDialogVisible = false;
            self.getTreedata(self.topicId, self.tuwenIndex, self.tuwenIndex1);
          } else if (self.level == 4) {
            self.setTree[self.tuwenIndex].children[self.tuwenIndex1].children[self.tuwenIndex2].children.push(list[0]);
            self.getFourdata(self.parentsId, self.tuwenIndex, self.tuwenIndex1, self.tuwenIndex2, self.level);
            self.activityDialogVisible = false;
          }
        } else {
          self.$message.warning(res.msg);
        }
      });
    },
    //添加互动弹窗中的分页方法
    onHandleSizeChange: function onHandleSizeChange(pageSize) {
      this.activityPagination.pageSize = pageISize;
      this.showInteraction(this.activityType);
    },
    //添加互动弹窗中的分页方法
    onPageChangeHandler: function onPageChangeHandler(pageIndex) {
      this.activityPagination.pageIndex = pageIndex;
      this.showInteraction(this.activityType);
    },
    //获取互动中的活动
    getInteraction: function getInteraction(topicId, level, parentsId, type, index, index1, index2) {
      this.activityDialogVisible = true;
      this.activityType = type;
      this.topicId = topicId;
      this.level = level;
      this.parentsId = parentsId;
      this.tuwenIndex = index;
      this.tuwenIndex1 = index1;
      this.tuwenIndex2 = index2;

      if (type == 5) {
        this.showhomeWork();
      } else {
        this.showInteraction(this.activityType);
      }
    },
    getInteraction_: function getInteraction_(topicId, level, parentsId, index, index1, type) {
      this.activityDialogVisible = true;
      this.activityType = type;
      this.topicId = topicId;
      this.level = level;
      this.parentsId = parentsId;
      this.tuwenIndex = index;
      this.tuwenIndex1 = index1;

      if (type == 5) {
        this.showhomeWork();
      } else {
        this.showInteraction(this.activityType);
      }
    },
    //获取互动弹窗中的数据
    showInteraction: function showInteraction(type) {
      var self = this;
      this.activityType = type;
      this.$http.post('/api/XOrg/CourseSectionIndex/getInteraction', {
        courseId: this.courseId,
        activityType: this.activityType,
        page: this.activityPagination.pageIndex
      }).then(function (res) {
        if (res.code > 0) {
          self.activityList = res.actlist;
          self.activityPagination = res.pagination;
        } else {
          self.$message.warning(res.msg);
        }
      });
    },
    //获取作业弹窗中的数据
    showhomeWork: function showhomeWork() {
      var self = this;
      this.$http.post('/api/XOrg/CourseSectionIndex/getTaskList', {
        courseId: this.courseId,
        page: this.activityPagination.pageIndex
      }).then(function (res) {
        if (res.code > 0) {
          self.activityList = res.actlist;
          self.activityPagination = res.pagination;
        } else {
          self.$message.warning(res.msg);
        }
      });
    },
    // 初始化获取数据（第一层）
    newGetCourseWareTree: function newGetCourseWareTree() {
      var self = this;
      this.loadingShow = true;
      this.$http.post('/api/XOrg/CourseSectionIndex/getModuleList', {
        courseId: self.courseId
      }).then(function (res) {
        var chartList = [];

        if (res.code > 0) {
          res.list.forEach(function (element) {
            var obj = {
              id: element.Id,
              index: element.index,
              isFirstModule: element.isFirstModule,
              name: element.ModuleName,
              sortOrder: element.sortOrder,
              Topnode: false,
              children: []
            };
            chartList.push(obj);
            self.setTree = chartList;
          });
          self.userId = res.userId;
          self.IsLoad = true;
          self.loadingShow = false;
        } else {
          self.$message.warning(res.msg);
        }
      });
    },
    // 获取第二层数据
    getNode: function getNode(id, index) {
      var self = this;
      this.grandIndex = index;
      this.grandId = id;
      this.loadingShow = true;
      var packing = [];

      if (this.setTree[index].children == '') {
        this.$http.post('/api/XOrg/CourseSectionIndex/getTopicSectionList', {
          courseId: this.courseId,
          ModuleId: id
        }).then(function (res) {
          if (res.code > 0) {
            if (res.list != '') {
              res.list.forEach(function (element) {
                var obj = {
                  id: element.Id,
                  index: element.index,
                  name: element.TopicName,
                  sortOrder: element.sortOrder,
                  upTopicId: element.upTopicId,
                  Twonode: false,
                  children: []
                };
                packing.push(obj);
              });
              self.$set(self.setTree[self.grandIndex], 'children', packing); // 判断当前Topnode来实现展开收起

              var setList = self.setTree[self.grandIndex].Topnode;

              if (setList == false) {
                self.$set(self.setTree[self.grandIndex], 'Topnode', true);
              } else {
                self.$set(self.setTree[self.grandIndex], 'Topnode', false);
              }
            } else {
              var _setList = self.setTree[self.grandIndex].Topnode;

              if (_setList == false) {
                self.$set(self.setTree[self.grandIndex], 'Topnode', true);
              } else {
                self.$set(self.setTree[self.grandIndex], 'Topnode', false);
              }
            }

            self.loadingShow = false;
          } else {
            self.$message.warning(res.msg);
          }
        });
      } else {
        var setList = self.setTree[self.grandIndex].Topnode;

        if (setList == false) {
          self.$set(self.setTree[self.grandIndex], 'Topnode', true);
        } else {
          self.$set(self.setTree[self.grandIndex], 'Topnode', false);
        }
      }
    },
    // 第三层显示背景  获取第三层的数据
    revealIcon: function revealIcon(id, index, index1) {
      this.fatherIcon = index;
      this.fatherIndex = index1;
      this.fatherId = id;
      this.loadingShow = true;
      var self = this;

      if (this.setTree[index].children[index1].children == '') {
        this.$http.post('/api/XOrg/CourseSectionIndex/getCellSectionList', {
          courseId: this.courseId,
          topicId: id
        }).then(function (res) {
          if (res.code > 0) {
            var list = [];
            res.list.forEach(function (element) {
              var obj = {
                CategoryName: element.CategoryName,
                CellContent: element.CellContent,
                CellName: element.CellName,
                CellType: element.CellType,
                CourseId: element.CourseId,
                DateCreated: element.DateCreated,
                DateModified: element.DateModified,
                DocId: element.DocId,
                DocSize: element.DocSize,
                ExternalLinkUrl: element.ExternalLinkUrl,
                Id: element.Id,
                ImpCourseId: element.ImpCourseId,
                ImpDocId: element.ImpDocId,
                ImpDocTitle: element.ImpDocTitle,
                NewSortOrder: element.NewSortOrder,
                PageCount: element.PageCount,
                ParentId: element.ParentId,
                RarJsonData: element.RarJsonData,
                ResId: element.ResId,
                ResourceUrl: element.ResourceUrl,
                SortOrder: element.SortOrder,
                TableName: element.TableName,
                TopicId: element.TopicId,
                VideoQuestionCount: element.VideoQuestionCount,
                VideoTimeLong: element.VideoTimeLong,
                ztWay: element.ztWay,
                paperType: element.paperType,
                threeNode: false,
                children: []
              };
              list.push(obj);
            });
            self.$set(self.setTree[index].children[index1], 'children', list);

            if (self.setTree[index].children[index1].Twonode == false) {
              self.$set(self.setTree[index].children[index1], 'Twonode', true);
            } else if (self.setTree[index].children[index1].Twonode == true) {
              self.$set(self.setTree[index].children[index1], 'Twonode', false);
            } else {
              self.$set(self.setTree[index].children[index1], 'Twonode', true);
            }

            self.loadingShow = false;
          } else {
            self.$message.warning(res.msg);
          }
        });
      } else {
        if (self.setTree[index].children[index1].Twonode == false) {
          self.$set(self.setTree[index].children[index1], 'Twonode', true);
        } else if (self.setTree[index].children[index1].Twonode == true) {
          self.$set(self.setTree[index].children[index1], 'Twonode', false);
        } else {
          self.$set(self.setTree[index].children[index1], 'Twonode', true);
        }
      }
    },
    // 获取第四层
    childIcon: function childIcon(id, index, index1, index2, type) {
      this.oneChild = index;
      this.towChild = index1;
      this.threeChild = index2;
      var self = this;

      if (type == 4) {
        this.$http.post('/api/XOrg/CourseSectionIndex/getCellSectionList', {
          courseId: this.courseId,
          topicId: id
        }).then(function (res) {
          if (res.code > 0) {
            self.$set(self.setTree[index].children[index1].children[index2], 'children', res.list);

            if (self.setTree[index].children[index1].children[index2].threeNode == false) {
              self.$set(self.setTree[index].children[index1].children[index2], 'threeNode', true);
            } else if (self.setTree[index].children[index1].children[index2].threeNode == true) {
              self.$set(self.setTree[index].children[index1].children[index2], 'threeNode', false);
            } else {
              self.$set(self.setTree[index].children[index1].children[index2], 'threeNode', true);
            }
          }
        });
      }
    },
    // 目录文件、互动预览
    previewFile: function previewFile(Id, type, sourceId, ResId, paperType) {
      var _this3 = this;

      //9.问卷调查,8.讨论,11.头脑风暴,5.测验,10.提问,6 作业
      if (type == 1) {
        this.sourceId = sourceId;
        GetSourceInfo(this.sourceId).then(function (rst) {
          if (rst.status === -1) {
            Message.warning('文件转换失败不能预览');
          } else if (rst.status === -2) {
            Message.warning('文件正在转换请稍后预览');
          } else if (rst.status === 1) {
            if (rst.docType === 7) {
              window.open(rst.docPriviewUrl, '_blank');
            } else {
              _this3.dialogVisiblePreviewResources = true;
            }
          }
        });
      } else if (type == 5) {
        this.$router.push({
          name: "checkschoolehomework",
          params: {
            courseId: this.courseId,
            paperId: ResId
          }
        }); //   window.open(href, '_blank', 'toolbar=yes, width=1300, height=900');
      } else if (type == 3) {
        this.getContentInfo(Id);
      } else {
        if (type == 7) {
          this.getVote(ResId);
        } else if (type == 9) {
          this.$router.push({
            name: "ShareSurveyCourseView",
            params: {
              courseId: this.courseId,
              questionnaireId: ResId
            }
          }); // window.open(href, '_blank', 'toolbar=yes, width=1300, height=900');
        } else if (type == 8) {
          this.discuss(ResId);
        } else if (type == 10) {
          this.quiz(ResId);
        } else if (type == 11) {
          this.Brainstorming(ResId);
        } else if (type == 6) {
          //题库
          if (paperType == 1) {
            this.$router.push({
              name: "checkschoolehomework",
              params: {
                courseId: this.courseId,
                paperId: ResId
              }
            }); //登分
          } else if (paperType == 2) {
            this.$router.push({
              name: "checkschoolehomework",
              params: {
                courseId: this.courseId,
                paperId: ResId
              }
            }); //附件
          } else if (paperType == 4) {
            this.$router.push({
              name: "checkschoolEnclosure",
              params: {
                courseId: this.courseId,
                paperId: ResId
              }
            });
          } // window.open(href, '_blank', 'toolbar=yes, width=1300, height=900');

        }
      }
    },
    // 获取投票详情
    getVote: function getVote(Id) {
      var _this4 = this;

      getVoteInfo(Id).then(function (rst) {
        _this4.isParticipate = true;
        _this4.titleType = "投票";
        _this4.voteInfo.ActivityName = rst.voteInfo.ActivityName;
        _this4.voteInfo.ActivityContent = rst.voteInfo.ActivityContent;
        _this4.voteInfo.DocJson = rst.voteInfo.DocJson.split(";");
        _this4.voteInfo.VoteType = rst.voteInfo.VoteType;
        _this4.voteInfo.DataJson = JSON.parse(rst.voteInfo.DataJson);

        _this4.voteInfo.DocJson.pop();
      });
    },
    // 获取讨论详情
    discuss: function discuss(Id) {
      var that = this;
      this.$http.post('/api/XOrg/CourseSectionIndex/getActivtyInfo', {
        acativtyId: Id
      }).then(function (res) {
        that.dialogVisibleDiscuss = true;
        that.info.CellName = res.activtyInfo.ActivityName;
        that.info.content = res.activtyInfo.ActivityContent;
      });
    },
    // 获取头脑风暴详情
    Brainstorming: function Brainstorming(Id) {
      var that = this;
      this.$http.post('/api/XOrg/CourseSectionIndex/getActivtyInfo', {
        acativtyId: Id
      }).then(function (res) {
        that.dialogVisibleBrainstorming = true;
        that.info.CellName = res.activtyInfo.ActivityName;
        that.info.content = res.activtyInfo.ActivityContent;
      });
    },
    // 获取提问详情
    quiz: function quiz(Id) {
      var that = this;
      this.$http.post('/api/XOrg/CourseSectionIndex/getActivtyInfo', {
        acativtyId: Id
      }).then(function (res) {
        that.titleType = "提问";
        that.isParticipate = true;
        that.voteInfo.ActivityName = res.activtyInfo.ActivityName;
        that.voteInfo.ActivityContent = res.activtyInfo.ActivityContent;
        that.voteInfo.DocJson = res.activtyInfo.DocJson.split(";");
        that.voteInfo.VoteType = res.activtyInfo.VoteType;
        that.voteInfo.DataJson = JSON.parse(res.activtyInfo.DataJson);
        that.voteInfo.DocJson.pop();
      });
    },
    // 获取文本内容详情
    getContentInfo: function getContentInfo(Id) {
      var self = this;
      this.$http.post('/api/XOrg/CourseSectionIndex/getContentInfo', {
        Id: Id
      }).then(function (res) {
        self.info = res.info[0];
        self.sdialogVisible = true;
      });
    },
    dialogClose: function dialogClose() {
      this.dialogVisiblePreviewResources = false;
      this.isParticipate = false;
    },
    // 作业测验查看
    previewQuestion: function previewQuestion(cell) {
      if (cell.ResId != '') {
        this.$router.push({
          name: 'courseWareQuestionBank',
          params: {
            courseId: this.courseId,
            cellId: cell.id,
            cellType: cell.cellType
          }
        });
      } else {
        this.$message.warning('课件不存在');
      }
    },
    //添加章弹窗显示
    handleAddTop: function handleAddTop() {
      this.chapterdialogFormVisible = true;
    },
    //添加章
    chapterAdd: function chapterAdd() {
      this.prevent = true;

      if (this.chapterName == '') {
        this.chapterName = '新建模块';
      }

      var self = this;
      this.$http.post('/api/XOrg/CourseSectionIndex/saveModule', {
        Id: '',
        courseId: this.courseId,
        moduleName: this.chapterName
      }).then(function (res) {
        if (res.code > 0) {
          var list = [];
          res.list.forEach(function (element) {
            var obj = {
              id: element.Id,
              courseId: element.CourseId,
              name: element.ModuleName,
              sortOrder: element.sortOrder,
              Topnode: false,
              children: []
            };
            list.push(obj);
          });
          self.setTree.push(list[0]);
          self.chapterName = '';
          self.prevent = false;
          self.$message.success('新建章成功！');
        } else {
          self.$message.warning(res.msg);
        }
      });
      this.chapterdialogFormVisible = false;
    },
    //添加节弹窗显示
    addSection: function addSection(moduleId, index) {
      this.sectiondialogFormVisible = true;
      this.moduleId = moduleId;
      this.topIndex = index;
    },
    //添加节
    sectionAdd: function sectionAdd() {
      this.prevent = true;

      if (this.sectionName == '') {
        this.sectionName = '新建节点';
      }

      var self = this;
      this.$http.post('/api/XOrg/CourseSectionIndex/saveTopic', {
        courseId: this.courseId,
        moduleId: this.moduleId,
        topicId: '',
        topicName: this.sectionName
      }).then(function (res) {
        if (res.code > 0) {
          var list = [];
          res.list.forEach(function (element) {
            var obj = {
              id: element.Id,
              name: element.TopicName,
              courseId: element.CourseId,
              moduleId: element.ModuleId,
              sortOrder: element.sortOrder,
              children: []
            };
            list.push(obj);
          });
          self.setTree[self.topIndex].children.push(list[0]);
          self.getTwodata(self.moduleId, self.topIndex);
          self.sectionName = '';
          self.prevent = false;
          self.$message.success(res.msg);
        } else {
          self.$message.warning(res.msg);
        }
      });
      this.sectiondialogFormVisible = false;
    },
    // 节点删除
    twoThreeNodeDelete: function twoThreeNodeDelete(id, index, index1, index2, index3) {
      var self = this;
      this.$http.post('/api/XOrg/CourseSectionIndex/deleteCell', {
        Id: id
      }).then(function (res) {
        if (res.code > 0) {
          if (index3 == undefined) {
            var list = self.setTree[index].children[index1].children;
            list.splice(index2, 1);
          } else {
            var _list = self.setTree[index].children[index1].children[index2].children;

            _list.splice(index3, 1);
          }

          self.$message.warning(res.msg);
        } else {
          self.$message.warning(res.msg);
        }
      });
    },
    // 删除节点
    NodeDel: function NodeDel(d, n, index, index1, index2, index3) {
      var _this5 = this;

      if (d.children && d.children.length !== 0) {
        this.$message.error('此节点有子级，不可删除！');
        return false;
      } else {
        var DelFun = function DelFun() {
          if (n.level === 1) {
            var self = _this5;

            _this5.$http.post('/api/XOrg/CourseSectionIndex/deleteModule', {
              Id: d.id == "undefined" ? d.Id : d.id
            }).then(function (res) {
              if (res.code > 0) {
                var list = self.setTree;
                list.splice(index, 1);
                self.$message.warning(res.msg);
              } else {
                self.$message.warning(res.msg);
              }
            });
          } else if (n.level === 2) {
            var _self = _this5;

            _this5.$http.post('/api/XOrg/CourseSectionIndex/deleteTopic', {
              Id: d.id
            }).then(function (res) {
              if (res.code > 0) {
                var list = _self.setTree[index].children;
                list.splice(index1, 1);

                _self.$message.warning(res.msg);
              } else {
                _self.$message.warning(res.msg);
              }
            });
          } else if (n.level === 3) {
            _this5.twoThreeNodeDelete(d.Id, index, index1, index2);
          } else if (n.level === 4) {
            _this5.twoThreeNodeDelete(d.Id, index, index1, index2, index3);
          }
        }; //二次确认


        var ConfirmFun = function ConfirmFun() {
          _this5.$confirm('是否确认删除？', '提示', {
            confirmButtonText: '确认',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(function () {
            DelFun();
          }).catch(function () {});
        }; //判断是否是新增节点


        d.id > this.non_maxexpandId ? DelFun() : ConfirmFun();
      }
    },
    //新建文件夹弹窗显示
    addFolder: function addFolder(topicId, item, index, index1) {
      this.folderdialogFormVisible = true;
      this.topicId = topicId;
      this.item = item;
      this.seIndex = index;
      this.seIndex1 = index1;
    },
    //打开资源
    getSource: function getSource(topicId, level, parentsId, index, index1, index2) {
      this.dialogFormVisibleSouce = true;
      this.topicId = topicId; // this.item = item;

      this.level = level;
      this.seIndex = index;
      this.seIndex1 = index1;
      this.seIndex2 = index2;
      this.parentsId = parentsId;
    },
    //新建文件夹
    folderAdd: function folderAdd() {
      this.prevent = true;

      if (this.folderName == '') {
        this.folderName = '新建文件夹';
      }

      var self = this;
      this.$http.post('/api/XOrg/CourseSectionIndex/saveCourseProcessCellNode', {
        Id: "",
        courseId: this.courseId,
        topicId: this.topicId,
        cellName: this.folderName
      }).then(function (res) {
        var list = [];

        if (res.code > 0) {
          res.cellList.forEach(function (element) {
            var obj = {
              Id: element.Id,
              CategoryName: element.categoryName,
              CellType: element.cellType,
              CourseId: element.courseId,
              FromType: element.fromType,
              ParentId: element.parentId,
              SortOrder: element.sortOrder,
              children: []
            };
            list.push(obj);
          });
          self.setTree[self.seIndex].children[self.seIndex1].children.push(list[0]);
          self.getTreedata(self.topicId, self.seIndex, self.seIndex1);
          self.folderName = '';
          self.prevent = false;
          self.$message.warning(res.msg);
        } else {
          self.$message.warning(res.msg);
        }
      });
      this.folderdialogFormVisible = false;
    },
    //打开图文添加窗口
    addtuwenwindow: function addtuwenwindow(topicId, level, parentsId, hierarchy, index, index1, index2) {
      this.topicId = topicId;
      this.level = level;
      this.parentsId = parentsId;
      this.tuwenIndex = index;
      this.tuwenIndex1 = index1;
      this.tuwenIndex2 = index2;
      this.hierarchy = hierarchy.hierarchy;
      this.tdialogVisible = true;
    },
    // 添加图文 
    savetuwen: function savetuwen() {
      var self = this;

      if (self.hierarchy == 2) {
        this.$http.post('/api/XOrg/CourseSectionIndex/saveCourseProcessCellPicWord', {
          courseId: self.courseId,
          topicId: self.topicId,
          cellLevel: 3,
          cellId: '',
          parentId: self.parentsId,
          cellName: self.tuwenName,
          cellContent: self.content,
          rarJsonData: ''
        }).then(function (res) {
          if (res.code > 0) {
            var list = [];
            res.cellList.forEach(function (element) {
              var obj = {
                Id: element.Id,
                CategoryName: element.categoryName,
                CellName: element.cellName,
                CellType: element.cellType,
                CourseId: element.courseId,
                IsAllowDownLoad: element.isAllowDownLoad,
                ParentId: element.parentId,
                ResourceUrl: element.resourceUrl,
                SortOrder: element.sortOrder
              };
              list.push(obj);
            });
            self.setTree[self.tuwenIndex].children[self.tuwenIndex1].children.push(list[0]);
            console.log(self.setTree[self.tuwenIndex].children[self.tuwenIndex1].children);
            self.getTreedata(self.topicId, self.tuwenIndex, self.tuwenIndex1);
            self.$message.warning(res.msg);
          } else {
            self.$message.warning(res.msg);
          }
        });
        self.tdialogVisible = false;
      } else if (self.hierarchy == 3) {
        this.$http.post('/api/XOrg/CourseSectionIndex/saveCourseProcessCellPicWord', {
          courseId: self.courseId,
          topicId: self.topicId,
          cellLevel: 4,
          cellId: '',
          parentId: self.parentsId,
          cellName: self.tuwenName,
          cellContent: self.content,
          rarJsonData: ''
        }).then(function (res) {
          if (res.code > 0) {
            var list = [];
            res.cellList.forEach(function (element) {
              var obj = {
                Id: element.Id,
                CategoryName: element.categoryName,
                CellName: element.cellName,
                CellType: element.cellType,
                CourseId: element.courseId,
                IsAllowDownLoad: element.isAllowDownLoad,
                ParentId: element.parentId,
                ResourceUrl: element.resourceUrl,
                SortOrder: element.sortOrder,
                children: []
              };
              list.push(obj);
            });
            self.setTree[self.tuwenIndex].children[self.tuwenIndex1].children[self.tuwenIndex2].children.push(list[0]);
            self.getFourdata(self.parentsId, self.tuwenIndex, self.tuwenIndex1, self.tuwenIndex2, self.level); // if (self.setTree[self.tuwenIndex].children[self.tuwenIndex1].children[self.tuwenIndex2].threeNode == false) {
            //     self.$set(self.setTree[self.tuwenIndex].children[self.tuwenIndex1].children[self.tuwenIndex2], 'threeNode', true);
            // } 

            self.$message.warning(res.msg);
          } else {
            self.$message.warning(res.msg);
          }
        });
        self.tdialogVisible = false;
      }
    },
    canceltuwen: function canceltuwen() {
      this.tdialogVisible = false;
    },
    // 上移
    moveUp: function moveUp(item, id, index, index1, index2, index3) {
      var currentlyId = id;
      var upId = '';
      var self = this;

      if (index2 == '0') {
        upId = item.children[index2].id;
      } else {
        upId = item.children[index2 - 1].id;
      }

      this.$http.post('/api/XOrg/CourseSectionIndex/dragCellPrev', {
        cellId: currentlyId,
        prevCellId: upId
      }).then(function (res) {
        if (res.code > 0) {
          // 根据index获取当前位置，当前位置下标减1
          if (index2 != 0 && index3 == undefined) {
            var setTreeList = self.setTree[index].children[index1].children[index2 - 1];
            self.$set(self.setTree[index].children[index1].children, index2 - 1, self.setTree[index].children[index1].children[index2]);
            self.$set(self.setTree[index].children[index1].children, index2, setTreeList);
          }

          if (index3 != 0 && index3 != undefined) {
            var _setTreeList = self.setTree[index].children[index1].children[index2].children[index3 - 1];
            self.$set(self.setTree[index].children[index1].children[index2].children, index3 - 1, self.setTree[index].children[index1].children[index2].children[index3]);
            self.$set(self.setTree[index].children[index1].children[index2].children, index3, _setTreeList);
          }
        } else {
          self.$message.warning(res.msg);
        }
      });
    },
    // 下移
    moveDown: function moveDown(item, id, index, index1, index2, index3) {
      var downId = '';
      var currentlyId = id;

      if (item.children.length - 1 == index2) {
        downId = item.children[index2].id;
      } else {
        downId = item.children[index2 + 1].id;
      }

      var self = this;
      this.$http.post('/api/XOrg/CourseSectionIndex/dragCellAfter', {
        cellId: currentlyId,
        afterCellId: downId
      }).then(function (res) {
        if (res.code > 0) {
          // 根据index获取当前位置，当前位置下标加1
          if (item.children.length - 1 != index2 && index3 == undefined) {
            var setTreeList = self.setTree[index].children[index1].children[index2 + 1];
            self.$set(self.setTree[index].children[index1].children, index2 + 1, self.setTree[index].children[index1].children[index2]);
            self.$set(self.setTree[index].children[index1].children, index2, setTreeList);
          }

          if (item.children.length - 1 != index3 && index3 != undefined) {
            var _setTreeList2 = self.setTree[index].children[index1].children[index2].children[index3 + 1];
            self.$set(self.setTree[index].children[index1].children[index2].children, index3 + 1, self.setTree[index].children[index1].children[index2].children[index3]);
            self.$set(self.setTree[index].children[index1].children[index2].children, index3, _setTreeList2);
          }
        } else {
          self.$message.warning(res.msg);
        }
      });
    },

    /*************** 上传相关 ********************/
    uphandleChange: function uphandleChange(file, fileList) {
      this.fileList = fileList;
      this.files = fileList;

      if (this.files.length > 0) {
        this.isShow = false;
        this.isupload = true;
        this.isfiles = true;
      } else {
        this.isShow = true;
        this.isupload = false;
        this.isfiles = false;
      }
    },
    onStartHandler: function onStartHandler() {
      this.$refs.upload.submit();
    },
    handlePreview: function handlePreview() {},
    handleRemove: function handleRemove(file, fileList) {
      this.fileList = fileList;
    },
    handChange: function handChange(file, fileList) {
      this.files = fileList;
      this.isAllUploadComplete();
    },
    handexceed: function handexceed(files, fileList) {
      alert('最多上传7个文件，本次可上传7个文件！');
    },
    handleProgess: function handleProgess(event, file, fileList) {},
    handleError: function handleError(err, file, fileList) {
      console.log(err);
    },
    // 上传成功
    handleSuccess: function handleSuccess(response, file, fileList) {
      this.successFiles.push(response);

      if (this.isAllUploadComplete()) {
        console.log(this.successFiles);
        this.saveSuccessFiles();
      }

      console.log(response); // this.saveLocalDocList();
    },
    saveSuccessFiles: function saveSuccessFiles() {
      var self = this;
      this.$http.post('/api/teacher/ecmdoc/saveEdocFiles', {
        files: JSON.stringify(self.files),
        parentId: self.parentId
      }).then(function (res) {
        self.$message({
          message: '文件上传成功',
          type: 'success'
        });
        self.visible = false;
        self.isShow = true;
        self.isupload = false;
        self.isfiles = false;

        if (self.isAllUploadComplete()) {
          self.$emit('done');
        }

        console.log(self.files);
        self.saveLocalDocList();
        self.fileList = [];
      });
    },
    initUploadVariable: function initUploadVariable() {
      var self = this;
      this.$http.post('/api/common/DFS/getUploadUrl').then(function (res) {
        self.uploadUrl = res.uploadUrl;
      });
    },
    disloagClose: function disloagClose() {
      // this.files=[];
      this.successFiles = [];
      this.$emit('done');
    },
    isAllUploadComplete: function isAllUploadComplete() {
      var flag = true;
      this.files.forEach(function (v) {
        if (v.status != 'success') {
          flag = false;
        }
      });
      console.log('是否已经完成上传？' + flag);
      return flag;
    },
    cancel: function cancel() {
      this.files = [];
      this.fileList = [];
      this.visible = false;
      this.isShow = true;
      this.isupload = false;
    },
    // //上传（新增）
    // handleCommand(command) {
    //     let self = this;
    //     switch (command.type) {
    //         case 'bendi':
    //             self.visible = true;
    //             self.files = [];
    //             self.successFiles = [];
    //             self.initUploadVariable();
    //             self.topicId = command.topicId;
    //             self.level = command.level;
    //             self.parentsId = command.parentsId;
    //             self.uploadIndex = command.index;
    //             self.uploadIndex1 = command.index1;
    //             self.uploadIndex2 = command.index2;
    //             self.uploadIndex3 = command.index3;
    //             break;
    //         case 'wode':
    //             self.topicId = command.topicId;
    //             self.dtype = 1;
    //             self.myfiledialogVisible = true;
    //             self.edocList();
    //             self.level = command.level;
    //             self.parentsId = command.parentsId;
    //             self.uploadIndex = command.index;
    //             self.uploadIndex1 = command.index1;
    //             self.uploadIndex2 = command.index2;
    //             self.uploadIndex3 = command.index3;
    //             break;
    //         case 'zhijiao':
    //             self.$router.push({
    //                 name: 'icveCourseWare',
    //                 params: {
    //                     courseId: self.courseId,
    //                     topicId: command.topicId,
    //                     parentId: command.parentsId,
    //                     cellId: '0',
    //                     importtype: 1
    //                 }
    //             });
    //             break;
    //         case 'xuexiao':
    //             self.topicId = command.topicId;
    //             self.dtype = 4;
    //             self.myfiledialogVisible = true;
    //             self.edocList();
    //             self.level = command.level;
    //             self.parentsId = command.parentsId;
    //             self.uploadIndex = command.index;
    //             self.uploadIndex1 = command.index1;
    //             self.uploadIndex2 = command.index2;
    //             self.uploadIndex3 = command.index3;
    //             break;
    //     }
    // },
    // // 替换
    // handleCommandChange(command) {
    //     let self = this;
    //     switch (command.type) {
    //         case 'bendi':
    //             self.visible = true;
    //             self.files = [];
    //             self.successFiles = [];
    //             self.initUploadVariable();
    //             self.cellId = command.cellId;
    //             self.replaceIndex = command.index;
    //             self.replaceIndex1 = command.index1;
    //             self.replaceIndex2 = command.index2;
    //             self.replaceIndex3 = command.index3;
    //             break;
    //         case 'wode':
    //             self.dtype = 1;
    //             self.myfiledialogVisible = true;
    //             self.edocList();
    //             self.cellId = command.cellId;
    //             self.replaceIndex = command.index;
    //             self.replaceIndex1 = command.index1;
    //             self.replaceIndex2 = command.index2;
    //             self.replaceIndex3 = command.index3;
    //             break;
    //         case 'zhijiao':
    //             self.$router.push({
    //                 name: 'icveCourseWare',
    //                 params: {
    //                     courseId: self.courseId,
    //                     topicId: command.topicId,
    //                     parentId: command.parentsId,
    //                     cellId: command.cellId,
    //                     importtype: 2
    //                 }
    //             });
    //             break;
    //         case 'xuexiao':
    //             self.dtype = 4;
    //             self.myfiledialogVisible = true;
    //             self.edocList();
    //             self.cellId = command.cellId;
    //             self.replaceIndex = command.index;
    //             self.replaceIndex1 = command.index1;
    //             self.replaceIndex2 = command.index2;
    //             self.replaceIndex3 = command.index3;
    //             break;
    //     }
    // },
    //分页方法
    handleCurrentChange: function handleCurrentChange(page) {
      this.edocList(page);
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.edocList(1);
    },
    myfilehandleSelectionChange: function myfilehandleSelectionChange(Id) {
      if (!this.checkedList[Id]) {
        this.checkedList[Id] = false;
        var index = this.Ids.indexOf(Id);
        this.Ids.splice(index, 1);
      } else {
        this.checkedList[Id] = true;
        this.Ids.push(Id);
      }
    },

    /****************** 拖动相关 *********************/
    // 第一层移动
    onInput: function onInput(newList) {
      var moduleId = [];

      for (var i = 0; i < newList.length; i++) {
        moduleId[i] = newList[i].id;
      }

      var self = this;
      this.$http.post('/api/XOrg/CourseSectionIndex/saveProcessModuleSortData', {
        moduleIds: moduleId
      }).then(function (res) {
        if (res.code > 0) {// self.$message.success(res.msg);
        } else {// self.$message.warning(res.msg);
          }
      });
    },
    // 第二层移动
    getInput: function getInput(newList) {
      var topicId = [];

      for (var i = 0; i < newList.length; i++) {
        topicId[i] = newList[i].id;
      }

      var self = this;
      this.$http.post('/api/XOrg/CourseSectionIndex/saveProcessTopicSortData', {
        topicIds: topicId
      }).then(function (res) {
        if (res.code > 0) {// self.$message.success(res.msg);
        } else {// self.$message.warning(res.msg);
          }
      });
    },
    // 第三层移动
    chInput: function chInput(newList) {
      var childId = [];

      for (var i = 0; i < newList.length; i++) {
        childId[i] = newList[i].Id;
      }

      var self = this;
      this.$http.post('/api/XOrg/CourseSectionIndex/saveProcessCellSortData', {
        cellIds: childId
      }).then(function (res) {
        if (res.code > 0) {// self.$message.success(res.msg);
        } else {// self.$message.warning(res.msg);
          }
      });
    },
    // 第四层移动
    grInput: function grInput(newList) {
      var grandId = [];

      for (var i = 0; i < newList.length; i++) {
        grandId[i] = newList[i].Id;
      }

      var self = this;
      this.$http.post('/api/XOrg/CourseSectionIndex/saveProcessChildCellSortData', {
        childCellIds: grandId
      }).then(function (res) {
        if (res.code > 0) {// self.$message.success(res.msg);
        } else {// self.$message.warning(res.msg);
          }
      });
    },
    sortEnd: function sortEnd() {},
    handleChange: function handleChange(val) {
      console.log(val);
    },
    secondHandleChange: function secondHandleChange(val) {
      console.log(val);
    },
    threeHandleChange: function threeHandleChange(val) {
      console.log(val);
    },
    fourHandleChange: function fourHandleChange(val) {
      console.log(val);
    },

    /*******      第一层     ********/
    // 输入框显示
    edit: function edit(index, chapterName) {
      this.inputShow = index;
      this.firstName = chapterName;
    },
    // 保存
    grandKeep: function grandKeep(name, id) {
      var self = this;
      this.$http.post('/api/XOrg/CourseSectionIndex/saveModule', {
        Id: id,
        courseId: this.courseId,
        moduleName: name
      }).then(function (res) {
        if (res.code > 0) {
          self.$message.warning(res.msg);
          self.inputShow = -1;
        } else {
          self.$message.warning(res.msg);
        }
      });
    },
    // 取消
    prohibit: function prohibit(item) {
      this.inputShow = -1;
      item.name = this.firstName;
    },

    /*******      第二层     ********/
    onFather: function onFather(index, index1, name) {
      this.fatherInput = index;
      this.twoInput = index1;
      this.nodeName = name;
    },
    fatherKeep: function fatherKeep(name, chapterId, id) {
      var self = this;
      this.$http.post('/api/XOrg/CourseSectionIndex/saveTopic', {
        courseId: this.courseId,
        moduleId: chapterId,
        topicId: id,
        topicName: name
      }).then(function (res) {
        if (res.code > 0) {
          self.$message.warning(res.msg);
          self.fatherInput = -1;
        } else {
          self.$message.warning(res.msg);
        }
      });
    },
    abrogate: function abrogate(item) {
      this.fatherInput = -1;
      item.name = this.nodeName;
    },

    /*******      第三层     ********/
    onChild: function onChild(index, index1, index2, name) {
      this.childInput = index;
      this.threeInput = index1;
      this.manyInput = index2;
      this.childNode = name;
    },
    childKeep: function childKeep(name, nodeId, id) {
      var self = this;
      this.$http.post('/api/XOrg/CourseSectionIndex/saveCourseProcessCellNode', {
        Id: id,
        courseId: this.courseId,
        topicId: nodeId,
        cellName: name
      }).then(function (res) {
        if (res.code > 0) {
          self.$message.warning(res.msg);
          self.childInput = -1;
          self.threeInput = -1;
        } else {
          self.$message.warning(res.msg);
        }
      });
    },
    childgate: function childgate(item) {
      this.childInput = -1;
      this.threeInput = -1;
      item.name = this.childNode;
    },

    /*******      第四层     ********/
    onSons: function onSons(index, index1, index2, index3, name) {
      this.grandInput = index;
      this.fourInput = index1;
      this.fiveIpnut = index2;
      this.sixInput = index3;
      this.sonsName = name;
    },
    sonsKeep: function sonsKeep(name, id) {
      var self = this;
      this.$http.post('/api/XOrg/CourseSectionIndex/savecellname', {
        courseId: this.courseId,
        cellId: id,
        cellName: name
      }).then(function (res) {
        if (res.code > 0) {
          self.$message.warning(res.msg);
          self.grandInput = -1;
          self.fourInput = -1;
          self.fiveIpnut = -1;
        } else {
          self.$message.warning(res.msg);
        }
      });
    },
    grandIcon: function grandIcon(index, index1, index2, index3) {
      this.oneGrand = index;
      this.twoGrand = index1;
      this.threeGrand = index2;
      this.fourGrand = index3;
    },
    grandgate: function grandgate(item) {
      this.grandInput = -1;
      this.fourInput = -1;
      this.fiveIpnut = -1;
      item.name = this.sonsName;
    },

    /****************************  用于添加节点、文件夹、互动 时展开层级  **********************************/
    // 初始化获取数据（第一层）
    getTopdata: function getTopdata() {
      var self = this;
      this.loadingShow = true;
      this.$http.post('/api/XOrg/CourseSectionIndex/getModuleList', {
        courseId: self.courseId
      }).then(function (res) {
        var chartList = [];

        if (res.code > 0) {
          res.list.forEach(function (element) {
            var obj = {
              id: element.Id,
              index: element.index,
              isFirstModule: element.isFirstModule,
              name: element.ModuleName,
              sortOrder: element.sortOrder,
              Topnode: false,
              children: []
            };
            chartList.push(obj);
            self.setTree = chartList;
          });
          self.userId = res.userId;
          self.IsLoad = true;
          self.loadingShow = false;
        } else {
          self.$message.warning(res.msg);
        }
      });
    },
    // 获取第二层数据
    getTwodata: function getTwodata(id, index) {
      var self = this;
      this.grandIndex = index;
      this.grandId = id;
      this.loadingShow = true;
      var packing = [];
      this.$http.post('/api/XOrg/CourseSectionIndex/getTopicSectionList', {
        courseId: this.courseId,
        ModuleId: id
      }).then(function (res) {
        if (res.code > 0) {
          if (res.list != '') {
            res.list.forEach(function (element) {
              var obj = {
                id: element.Id,
                index: element.index,
                name: element.TopicName,
                sortOrder: element.sortOrder,
                upTopicId: element.upTopicId,
                Twonode: false,
                children: []
              };
              packing.push(obj);
            });
            self.$set(self.setTree[self.grandIndex], 'children', packing); // 判断当前Topnode来实现展开收起

            var setList = self.setTree[self.grandIndex].Topnode;

            if (setList == false) {
              self.$set(self.setTree[self.grandIndex], 'Topnode', true);
            }
          }

          self.loadingShow = false;
        } else {
          self.$message.warning(res.msg);
        }
      });
    },
    // 第三层显示背景  获取第三层的数据
    getTreedata: function getTreedata(id, index, index1) {
      this.fatherIcon = index;
      this.fatherIndex = index1;
      this.fatherId = id;
      this.loadingShow = true;
      var self = this;
      this.$http.post('/api/XOrg/CourseSectionIndex/getCellSectionList', {
        courseId: this.courseId,
        topicId: id
      }).then(function (res) {
        if (res.code > 0) {
          var list = [];
          res.list.forEach(function (element) {
            var obj = {
              CategoryName: element.CategoryName,
              CellContent: element.CellContent,
              CellName: element.CellName,
              CellType: element.CellType,
              CourseId: element.CourseId,
              DateCreated: element.DateCreated,
              DateModified: element.DateModified,
              DocId: element.DocId,
              DocSize: element.DocSize,
              ExternalLinkUrl: element.ExternalLinkUrl,
              Id: element.Id,
              ImpCourseId: element.ImpCourseId,
              ImpDocId: element.ImpDocId,
              ImpDocTitle: element.ImpDocTitle,
              NewSortOrder: element.NewSortOrder,
              PageCount: element.PageCount,
              ParentId: element.ParentId,
              RarJsonData: element.RarJsonData,
              ResId: element.ResId,
              ResourceUrl: element.ResourceUrl,
              SortOrder: element.SortOrder,
              TableName: element.TableName,
              TopicId: element.TopicId,
              VideoQuestionCount: element.VideoQuestionCount,
              VideoTimeLong: element.VideoTimeLong,
              paperType: element.paperType,
              ztWay: element.ztWay,
              threeNode: false,
              children: []
            };
            list.push(obj);
          });
          self.$set(self.setTree[index].children[index1], 'children', list);

          if (self.setTree[index].children[index1].Twonode == false) {
            self.$set(self.setTree[index].children[index1], 'Twonode', true);
          }

          self.loadingShow = false;
        } else {
          self.$message.warning(res.msg);
        }
      });
    },
    // 获取第四层
    getFourdata: function getFourdata(id, index, index1, index2, type) {
      this.oneChild = index;
      this.towChild = index1;
      this.threeChild = index2;
      var self = this;

      if (type == 4) {
        this.$http.post('/api/XOrg/CourseSectionIndex/getCellSectionList', {
          courseId: this.courseId,
          topicId: id
        }).then(function (res) {
          if (res.code > 0) {
            self.$set(self.setTree[index].children[index1].children[index2], 'children', res.list);

            if (self.setTree[index].children[index1].children[index2].threeNode == false) {
              self.$set(self.setTree[index].children[index1].children[index2], 'threeNode', true);
            }
          }
        });
      }
    }
  }
};